import app from 'app';
import templateUrl from './family.html';
import './family.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

function FamilyController($state, $stateParams) {
  const Family = this;

  function getOption(member) {
    const { firstName, id } = member;
    return {
      label: firstName,
      name: firstName,
      sref: `Activity({patientId: '${id}'})`,
      value: id
    };
  }

  function getFamilyOptions(family, currentUser) {
    const options = [
      {
        label: 'Everyone',
        name: 'Everyone',
        sref: 'Activity({patientId: "0"})',
        value: 0
      },
      getOption(currentUser)
    ];

    Object.keys(family).map(key => {
      if (family[key].id !== currentUser.user.id) {
        options.push(getOption(family[key]));
      }
    });

    return options;
  }

  Family.$onInit = () => {
    Family.patients = getFamilyOptions(Family.family, Family.currentUser);
    Family.selectedPatientId = $stateParams.patientId || 0;
  };

  Family.clickLink = function() {
    logEvent('accumulatorsPersonFiltered', {
      category: eventCategories.ACTIVITY
    });
  };

  Family.updateSelectedPatient = patient => {
    const patientId = patient.value;
    logEvent('accumulatorsPersonFiltered', {
      category: eventCategories.ACTIVITY
    });
    Family.selectedPatientId = patientId;

    $state.go('Activity', { patientId });
  };
}

app.component('family', {
  bindings: {
    family: '<',
    currentUser: '<'
  },
  controller: FamilyController,
  controllerAs: 'Family',
  templateUrl
});

export default 'family';
